/**
 * A utility method to `extend` obj2 to obj1
 *
 * @param {Object} dest 
 * @param {Object} source
 */
module.exports = function(dest, source) {
  var keys = Object.keys(source);

  keys.forEach(function(key) {
    dest[key] = source[key];
  });

  return dest;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/extend.js
 ** module id = 1
 ** module chunks = 0
 **/